/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddPaymentDto } from '../models/AddPaymentDto';
import type { InvoiceDownloadResponseDto } from '../models/InvoiceDownloadResponseDto';
import type { InvoiceKpisResponseDto } from '../models/InvoiceKpisResponseDto';
import type { InvoiceReconciliationRunDetailResponseDto } from '../models/InvoiceReconciliationRunDetailResponseDto';
import type { InvoiceReconciliationUploadResponseDto } from '../models/InvoiceReconciliationUploadResponseDto';
import type { InvoiceResponseDto } from '../models/InvoiceResponseDto';
import type { InvoiceTransactionsResponseDto } from '../models/InvoiceTransactionsResponseDto';
import type { PaginatedInvoiceReconciliationRunsResponseDto } from '../models/PaginatedInvoiceReconciliationRunsResponseDto';
import type { PaginatedInvoicesResponseDto } from '../models/PaginatedInvoicesResponseDto';
import type { WriteOffDto } from '../models/WriteOffDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvoicesService {
    /**
     * List invoices
     * Supported filters: page, limit, status/statuses, type(s), payment method(s), payment type(s), client/adviser IDs, search, invoice number, client name, policy reference, and issue/due date range. Supports sortBy (invoiceNumber, policy, clientName, issueDate, dueDate, status, paymentType, outstanding, amount) and sortOrder (asc, desc).
     * @param page Page number (1-based)
     * @param limit Items per page (1-100)
     * @param status Filter by invoice status
     * @param clientId Filter by client UUID
     * @param search Search by invoice number, policy ID, or client name
     * @param statuses Filter by one or more invoice statuses
     * @param types Filter by one or more invoice types
     * @param paymentMethods Filter by one or more payment methods
     * @param paymentTypes Filter by one or more payment types
     * @param invoiceNumber Filter by invoice number (contains match)
     * @param clientName Filter by client name (contains match)
     * @param policyReference Filter by policy number/reference (contains match)
     * @param issueDateFrom Filter by issue date from (inclusive)
     * @param dueDateTo Filter by due date to (inclusive)
     * @param assignedAdviserId Filter by assigned adviser UUID
     * @param sortBy Sort field
     * @param sortOrder Sort order (default desc)
     * @returns PaginatedInvoicesResponseDto
     * @throws ApiError
     */
    public static invoicesControllerFindAll(
        page: number = 1,
        limit: number = 20,
        status?: 'DRAFT' | 'APPROVED' | 'AWAITING_PAYMENT' | 'PART_PAID' | 'OVERDUE' | 'FAILED' | 'PAID' | 'REFUNDED' | 'WRITTEN_OFF' | 'VOID',
        clientId?: string,
        search?: string,
        statuses?: Array<'DRAFT' | 'APPROVED' | 'AWAITING_PAYMENT' | 'PART_PAID' | 'OVERDUE' | 'FAILED' | 'PAID' | 'REFUNDED' | 'WRITTEN_OFF' | 'VOID'>,
        types?: Array<'ANNUAL' | 'INSTALMENT' | 'ADJUSTMENT' | 'RENEWAL' | 'MTA'>,
        paymentMethods?: Array<'DIRECT_DEBIT' | 'CREDIT_CARD' | 'BANK_TRANSFER' | 'PREMIUM_FUNDING' | 'OTHER'>,
        paymentTypes?: Array<'FUNDED' | 'ANNUAL'>,
        invoiceNumber?: string,
        clientName?: string,
        policyReference?: string,
        issueDateFrom?: string,
        dueDateTo?: string,
        assignedAdviserId?: string,
        sortBy?: 'invoiceNumber' | 'policy' | 'clientName' | 'issueDate' | 'dueDate' | 'status' | 'paymentType' | 'outstanding' | 'amount',
        sortOrder?: 'asc' | 'desc',
    ): CancelablePromise<PaginatedInvoicesResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices',
            query: {
                'page': page,
                'limit': limit,
                'status': status,
                'clientId': clientId,
                'search': search,
                'statuses': statuses,
                'types': types,
                'paymentMethods': paymentMethods,
                'paymentTypes': paymentTypes,
                'invoiceNumber': invoiceNumber,
                'clientName': clientName,
                'policyReference': policyReference,
                'issueDateFrom': issueDateFrom,
                'dueDateTo': dueDateTo,
                'assignedAdviserId': assignedAdviserId,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
            },
            errors: {
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Get invoice KPIs
     * Returns KPI aggregates (open invoices, overdue, failed debits in last 7 days, collected this month, and in arrears).
     * @returns InvoiceKpisResponseDto
     * @throws ApiError
     */
    public static invoicesControllerGetKpis(): CancelablePromise<InvoiceKpisResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/kpis',
            errors: {
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Download invoice reconciliation sample CSV
     * @returns binary
     * @throws ApiError
     */
    public static invoicesControllerGetReconciliationSampleCsv(): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/reconciliation/sample-csv',
        });
    }
    /**
     * Upload invoice reconciliation CSV
     * @param formData
     * @returns InvoiceReconciliationUploadResponseDto
     * @throws ApiError
     */
    public static invoicesControllerUploadReconciliationCsv(
        formData: {
            file: Blob;
        },
    ): CancelablePromise<InvoiceReconciliationUploadResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/reconciliation/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Invalid or missing CSV upload`,
            },
        });
    }
    /**
     * List invoice reconciliation runs
     * @param page Page number (1-based)
     * @param limit Items per page
     * @returns PaginatedInvoiceReconciliationRunsResponseDto
     * @throws ApiError
     */
    public static invoicesControllerListReconciliationRuns(
        page: number = 1,
        limit: number = 20,
    ): CancelablePromise<PaginatedInvoiceReconciliationRunsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/reconciliation/runs',
            query: {
                'page': page,
                'limit': limit,
            },
        });
    }
    /**
     * Get invoice reconciliation run detail
     * @param runId Invoice reconciliation run UUID
     * @param rowsLimit Maximum reconciliation rows to return
     * @returns InvoiceReconciliationRunDetailResponseDto
     * @throws ApiError
     */
    public static invoicesControllerGetReconciliationRunDetail(
        runId: string,
        rowsLimit: number = 500,
    ): CancelablePromise<InvoiceReconciliationRunDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/reconciliation/runs/{runId}',
            path: {
                'runId': runId,
            },
            query: {
                'rowsLimit': rowsLimit,
            },
        });
    }
    /**
     * Get invoice detail
     * @param invoiceId Invoice UUID
     * @returns InvoiceResponseDto
     * @throws ApiError
     */
    public static invoicesControllerFindById(
        invoiceId: string,
    ): CancelablePromise<InvoiceResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/{invoiceId}',
            path: {
                'invoiceId': invoiceId,
            },
            errors: {
                400: `Invoice not found`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * List invoice reconciliation transactions for invoice
     * @param invoiceId Invoice UUID
     * @returns InvoiceTransactionsResponseDto
     * @throws ApiError
     */
    public static invoicesControllerGetTransactions(
        invoiceId: string,
    ): CancelablePromise<InvoiceTransactionsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/{invoiceId}/transactions',
            path: {
                'invoiceId': invoiceId,
            },
            errors: {
                400: `Invoice not found`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Void (soft-delete) an invoice transaction
     * @param invoiceId Invoice UUID
     * @param transactionId Invoice transaction UUID
     * @returns void
     * @throws ApiError
     */
    public static invoicesControllerVoidTransaction(
        invoiceId: string,
        transactionId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/invoices/{invoiceId}/transactions/{transactionId}',
            path: {
                'invoiceId': invoiceId,
                'transactionId': transactionId,
            },
            errors: {
                400: `Invoice or transaction not found, or invoice has insurer/commission paid`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Get invoice PDF download URL
     * @param invoiceId Invoice UUID
     * @returns InvoiceDownloadResponseDto
     * @throws ApiError
     */
    public static invoicesControllerDownload(
        invoiceId: string,
    ): CancelablePromise<InvoiceDownloadResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/invoices/{invoiceId}/download',
            path: {
                'invoiceId': invoiceId,
            },
            errors: {
                400: `Invoice or invoice PDF not found`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Mark invoice as paid
     * @param invoiceId Invoice UUID
     * @returns InvoiceResponseDto
     * @throws ApiError
     */
    public static invoicesControllerMarkAsPaid(
        invoiceId: string,
    ): CancelablePromise<InvoiceResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/{invoiceId}/mark-paid',
            path: {
                'invoiceId': invoiceId,
            },
            errors: {
                400: `Invoice not found`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Mark invoice as unpaid
     * @param invoiceId Invoice UUID
     * @returns InvoiceResponseDto
     * @throws ApiError
     */
    public static invoicesControllerMarkAsUnpaid(
        invoiceId: string,
    ): CancelablePromise<InvoiceResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/{invoiceId}/mark-unpaid',
            path: {
                'invoiceId': invoiceId,
            },
            errors: {
                400: `Invoice not found or invoice is not paid`,
                401: `Unauthorized - JWT token missing/invalid`,
            },
        });
    }
    /**
     * Add payment to invoice
     * @param invoiceId Invoice UUID
     * @param requestBody
     * @returns InvoiceResponseDto
     * @throws ApiError
     */
    public static invoicesControllerAddPayment(
        invoiceId: string,
        requestBody: AddPaymentDto,
    ): CancelablePromise<InvoiceResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/{invoiceId}/add-payment',
            path: {
                'invoiceId': invoiceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invoice not found or amount invalid`,
            },
        });
    }
    /**
     * Write off an invoice amount
     * @param invoiceId Invoice UUID
     * @param requestBody
     * @returns InvoiceResponseDto
     * @throws ApiError
     */
    public static invoicesControllerWriteOff(
        invoiceId: string,
        requestBody: WriteOffDto,
    ): CancelablePromise<InvoiceResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/invoices/{invoiceId}/write-off',
            path: {
                'invoiceId': invoiceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invoice not found or write-off amount invalid`,
            },
        });
    }
}
